export default __webpack_public_path__ + "static/media/gmx_logo.2b33868e.svg";